import { render } from "./TransferenciasGRPage.vue?vue&type=template&id=9fd99726&scoped=true"
import script from "./TransferenciasGRPage.vue?vue&type=script&lang=js"
export * from "./TransferenciasGRPage.vue?vue&type=script&lang=js"

import "./TransferenciasGRPage.vue?vue&type=style&index=0&id=9fd99726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd99726"]])

export default __exports__